import { apiFetch, parseApiResponse } from '../../utils/apiClient';

export const getLdaAssignableUsers = async () => {
  const response = await apiFetch('/api/users/directory');
  return parseApiResponse(response);
};

export const getProjectLdaLines = async (projectId) => {
  const response = await apiFetch(`/api/module/lda/project/${projectId}`);
  return parseApiResponse(response);
};

export const generateProjectLda = async (projectId) => {
  const response = await apiFetch(`/api/module/lda/project/${projectId}/generate`, { method: 'POST' });
  return parseApiResponse(response);
};

export const replaceProjectLdaLines = async (projectId, lines) => {
  const response = await apiFetch(`/api/module/lda/project/${projectId}/replace`, {
    method: 'PUT',
    body: JSON.stringify({ lines }),
  });

  return parseApiResponse(response);
};

export const createProjectLdaLine = async (projectId, line) => {
  const response = await apiFetch(`/api/module/lda/project/${projectId}/lines`, {
    method: 'POST',
    body: JSON.stringify(line),
  });

  return parseApiResponse(response);
};

export const updateProjectLdaLine = async (projectId, lineId, changes) => {
  const response = await apiFetch(`/api/module/lda/project/${projectId}/lines/${lineId}`, {
    method: 'PUT',
    body: JSON.stringify(changes),
  });

  return parseApiResponse(response);
};

export const deleteProjectLdaLine = async (projectId, lineId) => {
  const response = await apiFetch(`/api/module/lda/project/${projectId}/lines/${lineId}`, {
    method: 'DELETE',
  });

  return parseApiResponse(response);
};

export const getLdaPublicationTarget = async (projectId, lineId) => {
  const response = await apiFetch(`/api/module/lda/project/${projectId}/lines/${lineId}/publication-target`);
  return parseApiResponse(response);
};

export const publishLdaFile = async (projectId, lineId, file) => {
  const response = await apiFetch(`/api/module/lda/project/${projectId}/lines/${lineId}/publish`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/octet-stream',
      'X-File-Name': encodeURIComponent(file.name || 'document.bin'),
      'X-File-Mime-Type': file.type || 'application/octet-stream',
    },
    body: file,
  });
  return parseApiResponse(response);
};

export const getInterventionLdaLines = async (interventionId) => {
  const response = await apiFetch(`/api/module/lda/intervention/${interventionId}`);
  return parseApiResponse(response);
};

export const createInterventionLdaLine = async (interventionId, line) => {
  const response = await apiFetch(`/api/module/lda/intervention/${interventionId}/lines`, { method: 'POST', body: JSON.stringify(line) });
  return parseApiResponse(response);
};

export const updateInterventionLdaLine = async (interventionId, lineId, changes) => {
  const response = await apiFetch(`/api/module/lda/intervention/${interventionId}/lines/${lineId}`, { method: 'PUT', body: JSON.stringify(changes) });
  return parseApiResponse(response);
};

export const deleteInterventionLdaLine = async (interventionId, lineId) => {
  const response = await apiFetch(`/api/module/lda/intervention/${interventionId}/lines/${lineId}`, { method: 'DELETE' });
  return parseApiResponse(response);
};

export const getInterventionLdaPublicationTarget = async (interventionId, lineId) => {
  const response = await apiFetch(`/api/module/lda/intervention/${interventionId}/lines/${lineId}/publication-target`);
  return parseApiResponse(response);
};

export const publishInterventionLdaFile = async (interventionId, lineId, file) => {
  const response = await apiFetch(`/api/module/lda/intervention/${interventionId}/lines/${lineId}/publish`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/octet-stream',
      'X-File-Name': encodeURIComponent(file.name || 'document.bin'),
      'X-File-Mime-Type': file.type || 'application/octet-stream',
    },
    body: file,
  });
  return parseApiResponse(response);
};
